import React, { useEffect } from 'react'
import BlogBanner from '../components/Blog/BlogBanner'
import BlogsAll from '../components/Blog/BlogsAll'
const BlogPage = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);
  return (
    <div>
      <BlogBanner />
      <BlogsAll />
    </div>
  )
}

export default BlogPage;
